import { render, staticRenderFns } from "./TitleGroup.vue?vue&type=template&id=54deb072&scoped=true"
import script from "./TitleGroup.vue?vue&type=script&lang=js"
export * from "./TitleGroup.vue?vue&type=script&lang=js"
import style0 from "./TitleGroup.vue?vue&type=style&index=0&id=54deb072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54deb072",
  null
  
)

export default component.exports